import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from './Header';
import { linkType } from '../../propTypes';
import { getSliceNavItems, getSliceContentType } from '../../selectors';
import Link from '../Link';

export const defaultAspects = {
  mobile: 414 / 512,
  desktop: 1440 / 920,
};

export const contentTopBiases = {
  sm: 2, // i.e. the ratio of the bottom padding to the top padding is 2:1
  md: 3 / 2,
  lg: 4 / 3,
};

const MAX_NAV_ITEMS = 3;
const Header1 = ({
  navItems, sliceId, ...props
}) => (
  <Header
    defaultAspects={defaultAspects}
    contentTopBiases={contentTopBiases}
    navItems={navItems.map((item, i) => (
      // eslint-disable-next-line react/no-array-index-key
      i < MAX_NAV_ITEMS ? <Link key={i} link={item} /> : null
    ))}
    sliceId={sliceId}
    {...props}
  />
);

Header1.propTypes = {
  navItems: PropTypes.arrayOf(linkType).isRequired,
  sliceId: PropTypes.number.isRequired,
};

Header1.defaultProps = {
};

const mapStateToProps = (state, { sliceId }) => ({
  navItems: getSliceNavItems(state, sliceId),
  contentType: getSliceContentType(state, sliceId),
});

export default connect(mapStateToProps)(Header1);
